// import libraries
import React from 'react';
import { useHistory } from 'react-router-dom';

// create a component
const RunEnginePage = () => {
  const history = useHistory();
  return (
    <div style={{ width: '100%' }} className="container-above-task-view-grid">
      <div
        className="link-to-view"
        style={{ cursor: 'pointer' }}
        onClick={() => {
          history.goBack();
        }}
      >
        <i className="fa fa-arrow-left">Back</i>
      </div>
      <iframe
        title="Engine Simulator"
        style={{ width: '100%', height: '100%' }}
        src="https://joyn2-demo.sevenlakes.com/routing_simulator/static/index.html"
      />
    </div>
  );
};

// make this component available to the app
export default RunEnginePage;
